// extracted by mini-css-extract-plugin
export var menuIcon = "_or-0";
export var menuIconInline = "_or-1";